import React from 'react';
import PropTypes from 'prop-types';

import { isFunction } from '../common/util';
import { omit } from '../helpers/util';

/** Creates a textarea element. */
class TextArea extends React.Component {
    constructor(props) {
        super(props);

        this.rest = omit(props, ['onChange', 'onBlur', 'onValueChange', 'onTouch', 'value']);

        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.value !== this.props.value;
    }

    hasOnValueChangeSubscriber() {
        return isFunction(this.props.onValueChange);
    }

    hasOnTouchSubscriber() {
        return isFunction(this.props.onTouch);
    }

    raiseValueChanged(value) {
        this.props.onValueChange(this.props.name, value);
    }

    raiseTouched() {
        this.props.onTouch(this.props.name);
    }

    onChange(event) {
        if (this.hasOnValueChangeSubscriber()) {
            this.raiseValueChanged(event.target.value);
        }
    }

    onBlur() {
        if (this.hasOnTouchSubscriber()) {
            this.raiseTouched();
        }
    }

    render() {
        return <textarea value={this.props.value} onChange={this.onChange} onBlur={this.onBlur} {...this.rest} />;
    }
}
TextArea.propTypes = {
    /** Input name.*/
    name: PropTypes.string.isRequired,

    /** The value. */
    value: PropTypes.string,

    /** The function called on value change. */
    onValueChange: PropTypes.func,

    /** The function called on touch. */
    onTouch: PropTypes.func
};
TextArea.defaultProps = {
    value: ''
};
export default TextArea;



// WEBPACK FOOTER //
// ./src/components/TextArea.js